import React, { useEffect, useRef, useState } from "react";
import { FormOutlined, MenuFoldOutlined, MenuUnfoldOutlined, MessageOutlined, UserOutlined } from "@ant-design/icons";
import { Layout, Avatar, Dropdown, Menu, Select, message, Table, TablePaginationConfig, Badge, Button, Tooltip, notification } from "antd";
import FontIcon from "../components/YhIcon";
import useGlobalModel from "../model/globalModel";
import useNavModel from "../model/navModel";
import Logo from "@/assets/images/header-logo.png"
import { ISearchPage, ISelectOption } from "@/types/FmsTypes";
// import { shopService } from "@/views/base/shop/shopService";
import { loginServiceAuth2 } from "@/views/login/LoginServiceAuth2";
import { closeWebPage } from "@/utils/utils";
import { shopService } from "@/views/base/shop/shopService";
import { isArray } from "util";
import { CLIENT_APP_CODE, DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from "@/utils/constants";
import { accountService } from "@/views/account/AccountService";
import { transPgToPagination } from "@/views/base/app/appModel";
import { IRechangeMsgFields, RechangeMsgEnum } from "@/views/account/AccountTypes";
import { ColumnsType } from "antd/lib/table";
import { useWebSocket } from "ahooks"

import { ActionTypeEnum, useDetailModel as useCustomerDetailModel } from "@/views/account/customerManage/view/detail/detailModel";
import { useRechargeModel as useCustomerRechargeModel } from "@/views/account/customerManage/view/detail/recharge/rechargeModel";
import { useAccountModel as useCustomerAccountModel } from "@/views/account/customerManage/view/detail/account/accountModel";
import { useAdjustModel as useCustomerAdjustModel } from "@/views/account/customerManage/view/detail/adjust/adjustModel";

import { useDetailModel as useSupplierDetailModel } from "@/views/account/supplierManage/view/detail/detailModel";
import { useRechargeModel as useSupplierRechargeModel } from "@/views/account/supplierManage/view/detail/recharge/rechargeModel";
import { useAccountModel as useSupplierAccountModel } from "@/views/account/supplierManage/view/detail/account/accountModel";
import { useAdjustModel as useSupplierAdjustModel } from "@/views/account/supplierManage/view/detail/adjust/adjustModel";
import { AdjustStatusEnum, RechargeStatusEnum } from "@/types/FmsEnums";
import { globalPrompt } from "@/components/YhMessage";
import WebSocketJSClass from "./webSocket";
import { useToastNotification } from "@/hooks/useToastNotification";
import { FullOrderEnum, useFullOrderModel } from '@/views/statistics/fullorder/fullOrderModel'
import { HomeModel } from '../views/home/index/view/HomeModel'
const { Header } = Layout;

function FmsHeader() {
    const initPgCfg: TablePaginationConfig = { pageSize: 5, current: DEFAULT_FIRST_PAGE_NUM }
    const { user, setUser, initUserState, shopDs,beShopDs, setBeShopDs, getShopUnit, getBranch } = useGlobalModel();
    const { setFullOrderStatus } = useFullOrderModel()
    const { initNav, addNav } = useNavModel();
    const [msgTabelVisible, setMsgTabelVisible] = useState(false)
    const { loadAll } = HomeModel();

    const loadMsg = async (page: ISearchPage = initPgCfg,) => {
        const { retData } = await accountService.rechangeMsgPage({
            status: 0,
            shopCodes: shopDs.map(item => item.code),
            page: {
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? initPgCfg.pageSize,
                pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
        })
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records.map(item => ({ ...item, key: item.id })));
    }
    /**
     * 跳转详情
     * @param detail 
     */
    const jumpMsgDetail = async (detail: IRechangeMsgFields) => {
        if (detail.shopCode !== user.shopCode) {
            return globalPrompt("message", {
                type: "warning",
                text: `该消息不在您当前登录门店下,请切换到${detail.shopName}门店`
            })
        }
        switch (detail.type) {
            case RechangeMsgEnum.RECHANGE:
                jumpRechangeList(detail)
                break;
            case RechangeMsgEnum.ADJUST:
                jumpAdjustList(detail)
                break;
            default:
                break;
        }
        if (detail.partnerTypeCode === "user-type.customer") {
            await initCustomerAccount(detail.partnerCode)
            setCustomerCode(detail.partnerCode);
            addNav("2-3-1");
        } else {
            await initSupplierAccount(detail.partnerCode)
            setSupplierCode(detail.partnerCode);
            addNav("2-4-1");
        }
    }

    const { wsRef } = useToastNotification({
        loadMsg,
        jumpMsgDetail
    })

    // 客户
    const {
        setCustomerCode,
        setActionType: setCustomerActionType
    } = useCustomerDetailModel(() => []);
    const {
        setCustomerUserDs,
        setCustomerUserList
    } = useCustomerAccountModel();
    const {
        updateSearchParam: updateCustomerSearchParam,
        setApprovalDrawerVisible: setCustomerRADVisible,
        setSelectedData: setCustomerRSetSelectData
    } = useCustomerRechargeModel()
    const {
        updateSearchParam: updateCustomerAdjustSearchParam
    } = useCustomerAdjustModel()

    // 供应商
    const {
        setSupplierCode,
        setActionType: setSupplierActionType
    } = useSupplierDetailModel(() => []);
    const {
        updateSearchParam: updateSupplierSearchParam,
        setApprovalDrawerVisible: setSupplierRADVisible,
        setSelectedData: setSupplierRSetSelectData
    } = useSupplierRechargeModel()
    const {
        setSupplierUserDs,
        setSupplierUserList
    } = useSupplierAccountModel();
    const {
        updateSearchParam: updateSupplierAdjustSearchParam,

    } = useSupplierAdjustModel()

    const [dataSource, setDataSource] = useState<IRechangeMsgFields[]>([])
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);

    const columns: ColumnsType<IRechangeMsgFields> = [
        {
            title: '客户',
            dataIndex: 'partnerName',
            width: "150px",
            align: "center",
            ellipsis: true,
        },
        {
            title: '客户类型',
            dataIndex: 'partnerTypeCode',
            width: "60px",
            align: "center",
            ellipsis: true,
            render: (v) => v === "user-type.customer" ? "客户" : "供应商"
        },
        {
            title: '账户',
            dataIndex: 'accountName',
            width: "150px",
            align: "center",
            ellipsis: true,
        },
        {
            title: '审核类型',
            dataIndex: 'type',
            width: "60px",
            align: "center",
            ellipsis: true,
            render: (v) => v === RechangeMsgEnum.ADJUST ? "调额" : "充值"
        },
        {
            title: '分支',
            dataIndex: 'branch',
            width: "60px",
            align: "center",
            ellipsis: true,
        },
        {
            title: '门店',
            dataIndex: 'shopName',
            width: "100px",
            align: "center",
            ellipsis: true,
        },
        {
            title: '状态',
            dataIndex: "status",
            width: "60px",
            ellipsis: true,
            align: "center",
            render: (v) => v === 0 ? "未处理" : "已处理"
        },
        {
            title: '操作',
            width: "60px",
            align: "center",
            ellipsis: true,
            render: (v, r) => <Tooltip title="去处理" color="purple" >
                <Button
                    type="link"
                    shape="circle"
                    size="small"
                    icon={<FormOutlined />}
                    onClick={() => jumpMsgDetail(r)}
                ></Button>
            </Tooltip>
        },
    ];

    useEffect(() => {
        loadMsg()
    }, [])

    useEffect(() => {
        msgTabelVisible && loadMsg()
    }, [msgTabelVisible])
    
    useEffect(() => {
        loadAll({});
    }, [beShopDs])



    /**
     * 充值详情
     * @param detail 
     */
    const jumpRechangeList = (detail: IRechangeMsgFields) => {
        if (detail.partnerTypeCode === "user-type.customer") {
            setCustomerActionType(ActionTypeEnum.RECHARGE_LIST)
            // setCustomerRSetSelectData({ key: 1, code: detail.code })
            // setCustomerRADVisible(true)
            updateCustomerSearchParam({
                accountCode: detail.accountCode,
                status: detail.status === 0 ? RechargeStatusEnum.INIT : undefined
            })
        } else {
            setSupplierActionType(ActionTypeEnum.RECHARGE_LIST);
            // setSupplierRSetSelectData({ key: 1, code: detail.code })
            // setSupplierRADVisible(true)
            updateSupplierSearchParam({
                accountCode: detail.accountCode,
                status: detail.status === 0 ? RechargeStatusEnum.INIT : undefined
            })
        }
    }

    /**
     * 调额详情
     * @param detail 
     */
    const jumpAdjustList = (detail: IRechangeMsgFields) => {
        if (detail.partnerTypeCode === "user-type.customer") {
            setCustomerActionType(ActionTypeEnum.ADJUST_LIST)
            updateCustomerAdjustSearchParam({
                accountCode: detail.accountCode,
                status: detail.status === 0 ? AdjustStatusEnum.REVIEWING : undefined
            })
        } else {
            setSupplierActionType(ActionTypeEnum.ADJUST_LIST);
            updateSupplierAdjustSearchParam({
                accountCode: detail.accountCode,
                status: detail.status === 0 ? AdjustStatusEnum.REVIEWING : undefined
            })
        }
    }

    /**
     * 初始客户列表
     * @param code 
     */
    const initCustomerAccount = async (code: string) => {
        const result = await accountService.find({ partnerCode: code })
        setCustomerUserList(result.retData)
        setCustomerUserDs(
            result?.retData.map(item => (
                {
                    label: item.name ?? '',
                    value: item.code ?? ''
                }
            ))
        )
    }

    /**
     * 初始化供应商列表
     * @param code 
     */
    const initSupplierAccount = async (code: string) => {
        const result = await accountService.find({ partnerCode: code })
        setSupplierUserList(result.retData)
        setSupplierUserDs(
            result?.retData.map(item => (
                {
                    label: item.name ?? '',
                    value: item.code ?? ''
                }
            ))
        )
    }


    //退出登录
    const onLogout = () => {
        if (user.loginType === "account") {
            setUser(initUserState);
            initNav();
            loginServiceAuth2.Logout();
            loginServiceAuth2.recordAppLogoutInfo(CLIENT_APP_CODE, user.userCode ?? "");
        } else {
            closeWebPage();
        }
    };

    // 菜单项
    const HeaderMenu = () => {
        const onClearCache = () => {
            initNav()
        }
        return (
            <Menu>
                <Menu.Item key="0">
                    <span onClick={onClearCache}>关闭所有标签</span>
                </Menu.Item>
            </Menu>
        )
    }

    const msgMenu = () => <div className="ant-dropdown-menu" style={{
        padding: "10px", background: "#fff", width: "800px"
    }}>
        <Table
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                showTotal: (total: number) => `共${total}条`,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadMsg({ pageNum, pageSize }).then();
                }
            }}
        />
    </div>

    //门店选择
    const onShopChang = async (value: string, options: ISelectOption) => {
        if (options && options.value) {
            initNav();  //清楚页签
            setUser({ ...user, shopId: value, shopName: options.label, shopCode: options.code as string ?? "", currencyName: options.currencyName as string });  //用户信息门店信息改变
            getShopUnit(options.code as string)
            message.success("切换门店成功");
            getBranch(options.code as string)
            setFullOrderStatus(FullOrderEnum.purchase)
            //切换门店， 设置对应门店下面的实体 缓存
            let { retData } = await shopService.one({
                sourceApp: "scm",
                branch: "main",
                code: options.code
            });
            let { details } = retData;
            if (isArray(details)) {
                setBeShopDs(details.map(item => ({
                    id: item.id,
                    label: item.bentityName ?? "",
                    value: item.bentityCode ?? ""
                })));
            } else {
                setBeShopDs([]);
            }
            //切换门店成功后 更新首页数据
            // loadAll({});
        }
    }

    // 关闭消息弹窗
    const handleVisibleChange = (visible: boolean) => {
        setMsgTabelVisible(visible)
    }

    return (
        <Header className="layout-section-header">
            {/* 左侧按钮 */}
            <div className="layout-sider-logo">
                <img className="layout-sider-logo-img" src={Logo} alt="财务管理系统Logo" />
                <span className="one-line">ERP-财务管理系统</span>
            </div>
            {/* 右侧内容 */}
            <div className="header-right" style={{ paddingRight: "15px" }}>

                <Select
                    showSearch
                    optionFilterProp="label"
                    defaultValue={user.shopId}
                    style={{ width: "250px" }}
                    className="header-right-item"
                    onChange={(value, options) => onShopChang(value, options as ISelectOption)}
                    options={shopDs}
                />

                {/* 消息 */}
                <Badge count={pgCfg.total} overflowCount={999} className="header-right-item">
                    <Dropdown overlay={msgMenu} placement="bottomCenter" visible={msgTabelVisible} onVisibleChange={handleVisibleChange} trigger={['click']}>
                        <Avatar className="config-icon" icon={<MessageOutlined />} />
                    </Dropdown>
                </Badge>

                {/* 设置 */}
                <Dropdown overlay={HeaderMenu} placement="bottomCenter" trigger={['click']}>
                    <Avatar className="header-right-item config-icon" icon={<FontIcon type="icon-shezhi" />} />
                </Dropdown>

                {/* 登录用户信息 */}
                <span onClick={e => e.preventDefault()} className="header-right-item user-info">
                    <Avatar
                        size="default"
                        icon={<UserOutlined />}
                        className="user-icon"
                    />
                    <span className="account">{user.userName ?? "未获取到"}</span>
                </span>

                {/* 退出登录 */}
                <FontIcon type="icon-tuichu" className="header-right-item logout-icon" onClick={() => onLogout()} />
            </div>
        </Header>
    )
}

export default FmsHeader;